/* Persist mat configurator choices across reload (same product only). */
(function () {
  var STORAGE_KEY = 'evmMatCfg:v1';
  var restoring = false;
  var saveTimer = null;

  function getRoot() {
    return document.querySelector('.product.config_container');
  }

  function productKey(root) {
    if (!root) return '';
    return root.getAttribute('data-product-id')
      || ((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '')
      || location.pathname;
  }

  function readStorage() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStorage(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function clearStorage() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function firstMatch(root, sels, suffix) {
    var list = String(sels || '').split(',');
    for (var i = 0; i < list.length; i++) {
      var sel = list[i].trim();
      if (!sel) continue;
      var el = root.querySelector(suffix ? (sel + ' ' + suffix) : sel);
      if (el) return el;
    }
    return null;
  }

  function radioPayload(root, scopeSel) {
    var inp = firstMatch(root, scopeSel, 'input[type="radio"]:checked');
    if (!inp || inp.tagName !== 'INPUT') return null;
    var dataValue = inp.getAttribute('data-value') || '';
    var value = inp.value || '';
    if (!dataValue && !value && !inp.id) return null;
    return {
      value: value,
      dataValue: dataValue,
      dataName: inp.getAttribute('data-name') || '',
      name: inp.name || '',
      id: inp.id || ''
    };
  }

  function isOptionalStep(w) {
    return !!(w && (
      w.classList.contains('product__dropdown_wr--heel')
      || w.classList.contains('product__dropdown_wr--extras')
      || w.getAttribute('data-dropdown') === 'extras'
      || w.getAttribute('data-dropdown') === 'heel'
    ));
  }

  function collect(root) {
    var yearEl = root.querySelector('#rok-produkcji');
    var uwagi = root.querySelector('#uwagi-do-zamowienia');
    var wrappers = Array.prototype.slice.call(root.querySelectorAll('.product__dropdown_wr'));
    var completed = [];
    var openKey = null;
    wrappers.forEach(function (w) {
      var key = stepKey(w);
      if (!key) return;
      var inner = w.querySelector('.product__dropdown_inner');
      // Heel/extras render with Liquid `super_done` by default — only count real Dalej completion.
      var reallyDone = w.classList.contains('complete') || w.classList.contains('evm-passed');
      if (!reallyDone && !isOptionalStep(w) && inner && inner.classList.contains('super_done')) {
        reallyDone = true;
      }
      if (reallyDone) completed.push(key);
      if (w.classList.contains('open')) openKey = key;
    });
    var summary = document.querySelector('.evm-summary.is-on:not([hidden])')
      || (document.querySelector('.evm-summary') && getComputedStyle(document.querySelector('.evm-summary')).display !== 'none' && document.querySelector('.evm-summary.is-on'));

    return {
      productKey: productKey(root),
      savedAt: Date.now(),
      fields: {
        year: yearEl ? yearEl.value : '',
        bodyType: radioPayload(root, '[data-dropdown="year"]'),
        gearbox: (function () {
          var inp = root.querySelector('input[name="properties[Skrzynia biegów]"]:checked');
          if (!inp) return null;
          return { value: inp.value || '', dataValue: inp.getAttribute('data-value') || '', dataName: inp.getAttribute('data-name') || '', name: inp.name || '', id: inp.id || '' };
        })(),
        brand: (root.querySelector('#marka_samochodu') || {}).value || '',
        model: (root.querySelector('#model_samochodu') || {}).value || '',
        matsType: radioPayload(root, 'fieldset[data-name="mats_type"], .product-form__input[data-name="mats_type"]'),
        matsSet: radioPayload(root, 'fieldset[data-name="mats_set"], .product-form__input[data-name="mats_set"]'),
        matPattern: radioPayload(root, '.lip__field[data-type="matPattern"], fieldset[data-type="matPattern"]'),
        matColor: radioPayload(root, '.lip__field[data-type="matColor"], fieldset[data-type="matColor"]'),
        trimColor: radioPayload(root, '.lip__field[data-type="trimColor"], fieldset[data-type="trimColor"]'),
        uwagi: uwagi ? uwagi.value : '',
        heel: collectChecks(root, 'input[name="product__upsell"]'),
        extras: collectChecks(root, 'input[name="product__extras"]')
      },
      wizard: {
        completed: completed,
        open: openKey,
        summary: !!summary
      }
    };
  }

  function collectChecks(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel)).filter(function (inp) {
      return inp.checked;
    }).map(function (inp) {
      var item = inp.closest('.product__upsell_item');
      var variants = [];
      if (item) {
        Array.prototype.forEach.call(item.querySelectorAll('.product__upsell_item_variant.active'), function (v) {
          variants.push({ optionIndex: (v.closest('.option-group') || {}).dataset.optionIndex || '', value: v.dataset.value || v.textContent.trim() });
        });
      }
      return { id: inp.id || '', value: inp.value || '', variants: variants };
    });
  }

  function stepKey(w) {
    if (!w) return null;
    var dd = w.getAttribute('data-dropdown');
    if (dd) return dd;
    if (w.classList.contains('product__dropdown_wr--heel')) return 'heel';
    if (w.classList.contains('product__dropdown_wr--extras')) return 'extras';
    return null;
  }

  function fire(el) {
    if (!el) return;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setRadio(root, scopeSel, payload) {
    if (!payload) return false;
    var scope = firstMatch(root, scopeSel) || root;
    function esc(s) {
      try { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/\\/g, '\\\\').replace(/"/g, '\\"'); }
      catch (e) { return String(s); }
    }
    var inp = null;
    if (payload.id) inp = document.getElementById(payload.id);
    if (!inp && payload.dataValue) {
      inp = scope.querySelector('input[type="radio"][data-value="' + esc(payload.dataValue) + '"]')
        || root.querySelector('input[type="radio"][data-value="' + esc(payload.dataValue) + '"]');
    }
    if (!inp && payload.dataName) {
      inp = scope.querySelector('input[type="radio"][data-name="' + esc(payload.dataName) + '"]');
    }
    if (!inp && payload.value != null && payload.value !== '') {
      Array.prototype.some.call(scope.querySelectorAll('input[type="radio"]'), function (c) {
        if (c.value === payload.value) { inp = c; return true; }
        return false;
      });
    }
    if (!inp) return false;
    // Prefer visible option if duplicates exist for pattern/color filters
    var item = inp.closest('.lip__item, label');
    if (item && item.offsetParent === null && payload.dataValue) {
      var visible = null;
      Array.prototype.some.call(root.querySelectorAll('input[type="radio"][data-value="' + esc(payload.dataValue) + '"]'), function (c) {
        var it = c.closest('.lip__item, label');
        if (it && it.offsetParent !== null) { visible = c; return true; }
        return false;
      });
      if (visible) inp = visible;
    }
    if (!inp.checked) inp.checked = true;
    fire(inp);
    return true;
  }

  function setChecks(root, items, sel) {
    if (!items || !items.length) return;
    Array.prototype.forEach.call(root.querySelectorAll(sel), function (inp) {
      var match = items.some(function (it) {
        return (it.id && inp.id === it.id) || (it.value && inp.value === it.value);
      });
      if (inp.checked !== match) {
        inp.checked = match;
        fire(inp);
      }
      var item = inp.closest('.product__upsell_item, .product__extras_item');
      if (item) item.classList.toggle('active', !!match);
      if (!match) return;
      var saved = items.find(function (it) {
        return (it.id && inp.id === it.id) || (it.value && inp.value === it.value);
      });
      if (!item || !saved || !saved.variants) return;
      saved.variants.forEach(function (v) {
        var group = v.optionIndex !== ''
          ? item.querySelector('.option-group[data-option-index="' + v.optionIndex + '"]')
          : item;
        if (!group) return;
        var btn = Array.prototype.find.call(group.querySelectorAll('.product__upsell_item_variant'), function (b) {
          return (b.dataset.value || '') === v.value || b.textContent.trim() === v.value;
        });
        if (btn) btn.click();
      });
    });
  }

  function applyWizard(root, wizard) {
    if (!wizard) return;
    var wrappers = Array.prototype.slice.call(root.querySelectorAll('.product__dropdown_wr'));
    var completed = wizard.completed || [];
    var openKey = wizard.open || null;
    var order = wrappers.map(stepKey);

    wrappers.forEach(function (w) {
      var key = stepKey(w);
      var inner = w.querySelector('.product__dropdown_inner');
      w.classList.remove('open', 'complete', 'disabled', 'evm-passed');
      if (inner) inner.classList.remove('open', 'done', 'super_done');
      if (!key) return;
      var done = completed.indexOf(key) >= 0;
      var isOpen = openKey && key === openKey;
      var idx = order.indexOf(key);
      var openIdx = openKey ? order.indexOf(openKey) : -1;
      if (done) {
        w.classList.add('complete', 'evm-passed');
        if (inner) inner.classList.add('done', 'super_done');
      }
      if (isOpen) {
        w.classList.add('open');
        if (inner) {
          inner.classList.add('open');
          inner.classList.remove('done');
        }
      } else if (openIdx >= 0 && idx > openIdx && !done) {
        w.classList.add('disabled');
      } else if (openIdx < 0 && !done && idx > 0 && completed.indexOf(order[0]) < 0) {
        /* keep liquid defaults if nothing restored meaningfully */
      }
    });

    // Unlock heel/extras if colors completed or summary
    if (completed.indexOf('mat_patterns_colors') >= 0 || wizard.summary) {
      wrappers.forEach(function (w) {
        if (w.classList.contains('product__dropdown_wr--heel') || w.classList.contains('product__dropdown_wr--extras')) {
          w.classList.remove('disabled');
        }
      });
    }

    if (wizard.summary) {
      wrappers.forEach(function (w) {
        w.classList.remove('open');
        var inner = w.querySelector('.product__dropdown_inner');
        if (inner) inner.classList.remove('open');
        if (!w.classList.contains('complete')) {
          w.classList.add('complete', 'evm-passed');
          if (inner) inner.classList.add('done', 'super_done');
        }
      });
      var summary = document.querySelector('.evm-summary');
      if (summary) {
        summary.classList.add('is-on');
        summary.removeAttribute('hidden');
        summary.style.display = '';
      }
    }
  }

  function scheduleSave(root) {
    if (restoring || !root) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        writeStorage(collect(root));
      } catch (e) {}
    }, 80);
  }

  function applyColors(root, f) {
    setRadio(root, '.lip__field[data-type="matColor"], fieldset[data-type="matColor"]', f.matColor);
    setRadio(root, '.lip__field[data-type="trimColor"], fieldset[data-type="trimColor"]', f.trimColor);
  }

  function restore(root, data) {
    if (!data || !data.fields) return;
    restoring = true;
    window.__evmMatCfgRestoring = true;
    window.__evmMatCfgSkipPairs = true;
    var f = data.fields;

    function finish() {
      restoring = false;
      window.__evmMatCfgRestoring = false;
      scheduleSave(root);
      window.dispatchEvent(new Event('resize'));
      document.dispatchEvent(new CustomEvent('evm-mat-cfg-restored'));
    }

    try {
      var yearEl = root.querySelector('#rok-produkcji');
      if (yearEl && f.year) {
        yearEl.value = f.year;
        fire(yearEl);
      }
      if (f.brand) {
        var brand = root.querySelector('#marka_samochodu');
        if (brand) { brand.value = f.brand; fire(brand); }
      }
      if (f.model) {
        var model = root.querySelector('#model_samochodu');
        if (model) { model.value = f.model; fire(model); }
      }

      setRadio(root, '[data-dropdown="year"]', f.bodyType);
      if (f.gearbox && f.gearbox.id) {
        var g = document.getElementById(f.gearbox.id);
        if (g) { g.checked = true; fire(g); }
      } else if (f.gearbox) {
        setRadio(root, '[data-dropdown="year"]', f.gearbox);
      }

      setTimeout(function () {
        setRadio(root, 'fieldset[data-name="mats_type"], .product-form__input[data-name="mats_type"], [data-dropdown="mats_set_type"]', f.matsType);
        setTimeout(function () {
          setRadio(root, 'fieldset[data-name="mats_set"], .product-form__input[data-name="mats_set"], [data-dropdown="mats_set_type"]', f.matsSet);
          setRadio(root, '.lip__field[data-type="matPattern"], fieldset[data-type="matPattern"]', f.matPattern);
          setTimeout(function () {
            applyColors(root, f);
            if (f.uwagi != null) {
              var uwagi = root.querySelector('#uwagi-do-zamowienia');
              if (uwagi) { uwagi.value = f.uwagi; fire(uwagi); }
            }
            setChecks(root, f.heel, 'input[name="product__upsell"]');
            setChecks(root, f.extras, 'input[name="product__extras"]');
            applyWizard(root, data.wizard);
            // Pattern→color reset / CRO can race; re-apply colors once more.
            setTimeout(function () {
              applyColors(root, f);
              finish();
            }, 180);
          }, 120);
        }, 80);
      }, 80);
    } catch (e) {
      finish();
    }
  }

  function boot() {
    var root = getRoot();
    if (!root || !root.querySelector('.product__dropdown_wr')) return;
    // Skip contact application form shells
    if (root.classList.contains('application_form__content') || root.closest('#popupOverlayApplicationForm')) return;

    var key = productKey(root);
    var stored = readStorage();
    if (stored && stored.productKey && stored.productKey !== key) {
      clearStorage();
      stored = null;
    }

    if (stored && stored.fields) {
      window.__evmMatCfgSkipPairs = true;
      // Wait for CRO / filterZestaw init
      setTimeout(function () { restore(root, stored); }, 280);
    }

    root.addEventListener('change', function () { scheduleSave(root); }, true);
    root.addEventListener('input', function (e) {
      if (e.target && (e.target.matches('textarea, select, input[type="text"]') || e.target.closest('.product__dropdown_wr'))) {
        scheduleSave(root);
      }
    }, true);
    root.addEventListener('click', function (e) {
      if (e.target && e.target.closest('.product__dropdown_button, .product__dropdown_title, .evm-pair, .product__upsell_item_variant')) {
        setTimeout(function () { scheduleSave(root); }, 160);
      }
    }, true);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        // Keep config after ATC for same product reload; do not clear.
      });
    }
  }

  // Early peek so CRO can skip default color pairs
  (function earlyPeek() {
    try {
      var root = getRoot();
      if (!root) return;
      var stored = readStorage();
      var key = productKey(root);
      var f = stored && stored.fields;
      function hasRadio(p) { return p && (p.dataValue || p.value || p.id); }
      if (stored && stored.productKey === key && f && (hasRadio(f.matColor) || hasRadio(f.trimColor) || hasRadio(f.matPattern))) {
        window.__evmMatCfgSkipPairs = true;
        window.__evmMatCfgRestoring = true;
      }
    } catch (e) {}
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
